import { render, staticRenderFns } from "./FilterNijmegen.vue?vue&type=template&id=407b98f4&"
import script from "./FilterNijmegen.vue?vue&type=script&lang=js&"
export * from "./FilterNijmegen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports